import {
  BOGGLE_COMMON_LETTER_VALUES,
  BOGGLE_MORE_COMMON_LETTER_ALLOWED_VALUES,
  BOGGLE_VOWEL_PARING_ALLOWED_VALUES,
} from '~/boggle/config/challengeModLetterConstants'
import { getBoggleLetterWeight } from '~/boggle/config/boardDistributions/letterWeights'

const MORE_COMMON_LETTER_EXCLUDED_VALUES = ['Q', 'V', 'K', 'B', 'U', 'J', 'X', 'Z']

export const MORE_COMMON_LETTER_PARAMETER_VARIANTS = BOGGLE_MORE_COMMON_LETTER_ALLOWED_VALUES.filter(
  letter => !MORE_COMMON_LETTER_EXCLUDED_VALUES.includes(letter),
).map(letter => ({
  id: `more-common-${letter.toLowerCase()}`,
  letter,
  weight: 1,
}))

export const VOWEL_VALUES = ['A', 'E', 'I', 'O', 'U'] as const
export const COMMON_ALLOWED_LETTERS = [...VOWEL_VALUES, ...BOGGLE_COMMON_LETTER_VALUES]

export const VOWEL_PARING_VARIANTS = BOGGLE_VOWEL_PARING_ALLOWED_VALUES.map(pair => {
  const allowedVowels = pair.split('/') as [string, string]

  return {
    allowedVowels,
    id: `vowel-paring-${pair.toLowerCase().replace('/', '-')}`,
    pair,
    weight: 1,
  }
})

export function createPositiveLetterWeightVariants(
  letterWeights: ReadonlyArray<readonly [string, number]>,
) {
  return letterWeights
    .filter(([, weight]) => weight > 0)
    .map(([letter, weight]) => ({
      id: `letter-${letter.toLowerCase()}`,
      letter,
      weight,
    }))
}

function getVeryCommonMultiplierForWeight(weight: number) {
  if (weight <= 4) {
    return 7
  }

  if (weight <= 6) {
    return 5
  }

  return 4
}

export function getBoggleMoreCommonLetterMultiplier(letter: string) {
  return getVeryCommonMultiplierForWeight(getBoggleLetterWeight(letter) || 1)
}

export const BOGGLE_MORE_COMMON_MULTIPLIER_VALUES = Object.freeze(
  [
    ...new Set(
      BOGGLE_MORE_COMMON_LETTER_ALLOWED_VALUES.map(getBoggleMoreCommonLetterMultiplier),
    ),
  ].sort((first, second) => first - second),
)
